<template>
  <div>
    <b-row>
      <b-col>
        <b-form-input v-model="search" placeholder="Busca..." class="mb-2" debounce="500"></b-form-input>
      </b-col>
<!--      Antigo filtro -->
<!--      <b-col sm="auto">-->
<!--        {{ $store.state[namespace].total }} items-->
<!--        <div v-if="showFilter">-->
<!--          <span class="badge badge-success" @click="filter='paid'">pago</span>-->
<!--          <span class="badge badge-danger" @click="filter='no_paid'" style="margin-left: 5px;">não pago</span>-->
<!--          <a href="#" style="margin-left: 5px;" @click.prevent="filter='all'">Limpar</a>-->
<!--        </div>-->
<!--      </b-col>-->
    </b-row>
    <table class="table table-striped">
      <thead>
        <tr>
          <slot name="header"></slot>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in items" :key="item.pk">
          <slot name="item" :item="item"></slot>
        </tr>
      </tbody>
    </table>

    <div v-if="showPagination" style="text-align: right;">
      <b-pagination
        :total-rows="$store.state[namespace].total"
        :per-page="$store.state[namespace].perPage"
        v-model="currentPage"
        style="display: inline-flex;"
      ></b-pagination>
    </div>
  </div>
</template>
<script>
export default {
  computed: {
    items() {
      return this.sortByExpirationDate(this.$store.state[this.namespace].items);
    },
  },
  methods: {
    // Ordena os reembolsos a receber do vencimento mais próximo ao mais antigo, em ordem alfabética.
    sortByExpirationDate(items) {
      return items.sort((a, b) => {
        const dateA = new Date(a.expiration_date);
        const dateB = new Date(b.expiration_date);
        let nameA = '';
        let nameB = '';

        if (a.employee || b.employee) {
          nameA = a.employee.full_name.toLowerCase();
          nameB = b.employee.full_name.toLowerCase();
        }

        if (dateA < dateB) {
          return 1;
        } else if (dateA > dateB) {
          return -1;
        } else {
          if (nameA < nameB) {
            return -1;
          } else if (nameA > nameB) {
            return 1;
          } else {
            return 0;
          }
        }
      });
    },
  },
  props: ['title', 'namespace', 'searchFields', 'searchObject', 'showFilter', 'showPagination'],
  data() {
    return {
      search: '',
      filter: 'all',
      currentPage: 1,
    }
  },
  mounted() {
    this.currentPage = this.$store.state[this.namespace].page;
    this.$store.dispatch(this.namespace + '/loadItems', {
      search: '',
      filter: this.filter,
      page: this.currentPage
    });
  },
  watch: {
    currentPage(page) {
      this.$store.dispatch(this.namespace + '/loadItems', {
        search: this.search,
        filter: this.filter,
        page: page
      });
    },
    search(newVal) {
      if (newVal.length < 3 && newVal.length != 0) {
        return;
      }

      this.$store.dispatch(this.namespace + '/loadItems', {
        search: newVal,
        filter: this.filter,
        page: 1
      });
    },
    filter(filter) {
      this.$store.dispatch(this.namespace + '/loadItems', {
        search: this.search,
        filter: filter,
        page: this.currentPage
      });
    },
  },
}

</script>
